<template>
    <div class="inner-wrapper">
        <div class="alert alert-success" role="alert" v-if="successMessage">
            {{ successMessage }}
        </div>

        <div
            v-if="commonErrors.length != 0"
            class="alert alert-danger alert-dismissible"
        >
            <a href="#" class="close" data-dismiss="alert" aria-label="close"
                >&times;</a
            >
            <ul>
                <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                        {{ error }}
                    </p>
                </li>
            </ul>
        </div>

        <div class="page-title page-shipping page-title-full mb-3 order-row-custom">
                    <div class="order-number-col">
                        <div class="float-left">
                            <a href="javasccript:void(0)" @click="backTo()" class="btn custom-btn"><i class="ri-arrow-left-s-line"></i></a>

                            

                            <!-- <router-link
                                :to="{name:'purchaseOrders'}"
                                class="btn custom-btn"
                                style="
                                    font-size: 26px;
                                    line-height: 26px;
                                    padding: 4px 8px 1px;
                                "
                                ><i class="ri-arrow-left-s-line"></i
                            ></router-link> -->
                            
                        </div>
                        

                        <div class="d-flex align-items-center">
                            <div class="order-number" v-if="!isEditMode && shippingData != null">
                                #
                               <template v-if="shippingData.shipping_number == null">
                               {{shippingData.id}}
                               </template>
                               <template v-else>
                               {{shippingData.shipping_number}}
                               </template>
                                
                                
                            </div>
                            <!-- <div class="order-number" v-if="!isEditMode && shippingData != null">
                                Shifl Status {{shipment_detail.shipment_status}}
                            </div> -->
                            

                            <!-- <div class="order-number-edit" v-if="isEditMode">
                                <input
                                    type="text"
                                    
                                    placeholder=""
                                    class="form-control"
                                />
                            </div>
                            <div class="order-number-edit" v-if="isEditMode">
                                <input
                                    type="text"
                                    
                                    placeholder=""
                                    class="form-control"
                                />
                            </div> -->

                            <div class="order-number-edit" v-if="isEditMode">
                                    <label class="form-label">Shipment Id</label>
                                    <input type="text" name="tracking_no" class="form-control" v-model="form.shipping_number">
                                        <!-- <label class="form-label">Status</label>
                                        <select
                                            class="form-select"
                                            v-model="form.status"
                                        >
                                            <option value="1">
                                                Not initiated
                                            </option>
                                            <option value="2">Shipped</option>
                                            <option value="3">
                                                In Transit
                                            </option>
                                            <option value="4">Delivered</option>
                                        </select> -->
                                   
                            </div>

                            <!-- <div class="order-number-edit" v-if="isEditMode">
                                <label class="form-label"
                                            >Shipping Type</label
                                        >
                                        <ValidationProvider
                                            name="Carrier Type"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                class="form-select"
                                                v-model="form.shipping_type"
                                            >
                                                <template
                                                    v-if="
                                                        shippingTypeOptions.length >
                                                        0
                                                    "
                                                >
                                                    <template
                                                        v-for="(
                                                            shippingTypeOption,
                                                            index
                                                        ) in shippingTypeOptions"
                                                    >
                                                        <option
                                                            :value="
                                                                shippingTypeOption
                                                            "
                                                        >
                                                            {{
                                                                shippingTypeOption
                                                            }}
                                                        </option>
                                                    </template>
                                                </template>
                                                
                                            </select>
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                            </div> -->

                            <div class="cpreder">
                                <a
                                    v-if="!isEditMode &&
                                    ((getUser != null && getUser.user_type == 1) ||
                                    hasRole('Admin') ||
                                    hasPerm('edit-shipping'))"
                                    href="javascript:void(0);"
                                    class="btn btn-secondary"
                                    
                                    v-on:click="changeEditMode(true)"
                                    ><i
                                        class="ri-edit-box-line pe-1 align-middle"
                                    ></i
                                    >Edit</a
                                >
                                <button
                                    v-if="isEditMode"
                                    type="button"
                                    :disabled="loading"
                                    class="btn btn-success ml-1"
                                    @click="shipEditSave"
                                >
                                    Save
                                </button>
                                <button
                                    v-if="isEditMode"
                                    type="button"
                                    :disabled="loading"
                                    class="btn custom-btn ml-1"
                                    @click="
                                        isEditMode = false;
                                        getOrder();
                                    "
                                >
                                    Cancel
                                </button>

                                <a
                                    v-if="!isEditMode &&
                                    ((getUser != null && getUser.user_type == 1) ||
                                    hasRole('Admin') ||
                                    hasPerm('edit-shipping'))"
                                    href="javascript:void(0);"
                                    class="btn btn-secondary"
                                    
                                    v-on:click="downloadExcel(1)"
                                    >Generate ISF</a
                                >

                            </div>
                        </div>
                    </div>
                             
                    

                    
                </div>

                <!-- <div class="page-title page-shipping page-title-full mb-3 order-row-custom">
                    <div class="order-number-col">
                        <div class="d-flex align-items-center">
                            <div class="order-number" v-if="shipment_detail != null">
                               Supplier Name : <template
                                    v-for="(
                                        shipmentSingle,
                                        index
                                    ) in shipment_detail.shippers"
                                >
                                    {{
                                        shipmentSingle.name
                                    }}
                                </template>
                            </div>
                        </div>
                    </div>
                </div> -->

        <div class="select-step">
            <div class="row">
                <div class="col-sm-9 col-md-9 col-xxl-10">



                <!-- New Html -->

                <div class="card custom-card">
                                    <div class="card-body py-3">
                                        <div class="mt-0 d-flex justify-content-between align-items-center">
                                            <div class="d-flex align-items-center">
                                                <h5 class="card-title fw-medium me-2 mb-0 fshe" style="">#<template v-if="order != null">{{ order.order.order_number }}</template></h5>
                                                <div class="she" style="display: none;"><input type="" name="" class="form-control form-control-sm hasedit" value="4567"></div>
                                                <!-- <a href="javascript: void(0);" style="margin-top: 0px;" class="rtn-edit fshe" id="edit" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Edit" aria-label="Edit"><i class="ri-edit-fill text-danger me-1"></i></a>
                                                <div class="ms-2 text-end she" style="display: none;">
                                                    <button class="btn btn-sm btn-danger me-1" id="edit-cancel">Cancel</button>
                                                    <button class="btn btn-sm btn-primary">Save Now</button>
                                                </div> -->
                                            </div>
                                            <!-- <div class="fw-medium fs-15 color-h ms-2">Supplier Name : TEC-FOLIEN-ALGAU GMBH</div> -->
                                        </div>
                                    </div>

                                    <div class="custom-block shipment-block">
                                        <ul class="nav nav-pills nav-light mb-0 ms-3" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" data-toggle="tab" href="#arrow-shipinfo" role="tab" aria-selected="true">
                                                    <span class="d-block d-sm-none"><i class="ri-truck-line"></i></span>
                                                    <span class="d-none d-sm-block"> Shipment Info</span> 
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#arrow-iteminfo" role="tab" aria-selected="false">
                                                    <span class="d-block d-sm-none"><i class="ri-information-line"></i></span>
                                                    <span class="d-none d-sm-block"> Item Info</span>   
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#arrow-docs" role="tab" aria-selected="false">
                                                    <span class="d-block d-sm-none"><i class="ri-article-line"></i></span>
                                                    <span class="d-none d-sm-block"> Documents</span>   
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#arrow-bills" role="tab" aria-selected="false">
                                                    <span class="d-block d-sm-none"><i class="ri-bill-line"></i></span>
                                                    <span class="d-none d-sm-block"> Bills</span>   
                                                </a>
                                            </li>
                                        </ul>
                                        <!-- Tab panes -->
                                        <div class="tab-content card-body text-muted">
                                            <div class="tab-pane active" id="arrow-shipinfo" role="tabpanel">
                                                <div class="d-flex justify-content-end mb-2">
                                                   <a href="javascript: void(0);" class="rtn-edit" data-toggle="modal" data-target="#editShipmentInfoModal"><i class="ri-edit-fill me-1"></i> Edit</a>
                                                </div>
                                                <div class="table-responsive table-card mt-0 m-0">
                                                    <table class="table table-bordered align-start mb-0">
                                                        <thead class="table-light text-muted">
                                                            <tr>
                                                                <th style="width: 7%;" scope="col">Order numbers</th>
                                                                <th scope="col">MBL</th>
                                                                <th style="width: 7%;" scope="col">Final Destination</th>
                                                                <th scope="col">Port of Loading</th>
                                                                <th scope="col">Port of Discharge</th>
                                                                <th style="width: 10%; min-width:100px;" scope="col">ETD</th>
                                                                <th style="width: 10%; min-width:100px;" scope="col">ETA</th>
                                                                <th style="width: 7%;" scope="col">Shipping Method</th>
                                                                <th style="width: 7%;" scope="col">Shipping Type</th>
                                                                <th style="width: 10%; min-width:100px;" scope="col">Carrier</th>
                                                                <th scope="col">Terminal</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-if="shippingData != null">
                                                    
                                                    <td>
                                                    <template v-if="order != null">
                                                    {{ order.order.order_number }}
                                                    </template>
                                                    
                                                    </td>
                                                    <td>
                                                        {{
                                                            shippingData.tracking_no
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            shippingData.final_destination
                                                        }}
                                                    </td>
                                                    <td>{{  shipment_detail ? shipment_detail.location_from : '' }}
                                                        
                                                        
                                                    </td>
                                                    <td>{{  shipment_detail ? shipment_detail.location_to : '' }}
                                                        
                                                       
                                                    </td>
                                                    <td>
                                                        <template
                                                            v-for="(
                                                                shipmentSingle,
                                                                index
                                                            ) in shipment_detail.scheduling_options"
                                                        >
                                                            {{
                                                                shipmentSingle.etd
                                                            }}
                                                        </template>
                                                    </td>
                                                    <td>
                                                        <template
                                                            v-for="(
                                                                shipmentSingle,
                                                                index
                                                            ) in shipment_detail.scheduling_options"
                                                        >
                                                            {{
                                                                shipmentSingle.eta
                                                            }}
                                                        </template>
                                                    </td>
                                                    
                                                    <td>
                                                        {{
                                                            shippingData.carrier_type ==
                                                            1
                                                                ? "Air"
                                                                : "Occean"
                                                        }}
                                                    </td>
                                                    <td>{{ shipment_detail ? shipment_detail.type : ""}}

                                                    </td>
                                                    <td>
                                                         {{
                                                                shipment_detail.carrier
                                                            }}
                                                    </td>
                                                    <td>
                                                        
                                                            {{
                                                                shipment_detail.shipmentTerminalInfo ? shipment_detail.shipmentTerminalInfo.name : "" 
                                                            }}
                                                        
                                                    </td>
                                                    
                                                </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div class="card-header mt-2 p-0 border-0">
                                                    <div class="row g-0">
                                                        <div class="col-12 col-sm-12">
                                                            <div class="px-3 py-12 border border-dashed">
                                                                <p class="mb-0"><span class="fw-semibold color-h">Ship To Address:</span> 
                                                                <span>
                                                                <template v-if="order != null">
                                                        <template v-if="order.order.customer_warehouses && order.order.customer_warehouses.length">

                                                        <template  v-for="(item, index) in order.order.customer_warehouses">
                                                            {{ item.address }}
                                                                <!-- <template v-if="item.warehouse">
                                                                    {{ item.warehouse.address2 }}
                                                                    {{ item.warehouse.address }}
                                                                    {{ item.warehouse.state }}
                                                                    {{ item.warehouse.city }}
                                                                    {{ item.warehouse.post_code }}
                                                                </template>
                                                                <template v-else>
                                                                    {{ item.address }}
                                                                </template> -->
                                                            </template>
                                                        
                                                            </template>
                                                            
                                                        </template>
                                                                </span>
                                                                
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <!--end col-->
                                                    </div>
                                                </div>

                                                <div class="mt-3">
                                                    <h5 class="card-title mb-2 fw-semibold">Container</h5>
                                                    <div class="table-responsive table-card mt-0 m-0">
                                                        <table class="table table-bordered align-start mb-0">
                                                            <thead class="table-light text-muted">
                                                                <tr>
                                                                    <th scope="col">Container number</th>
                                                                    <th scope="col">Size</th>
                                                                    <th scope="col">Volume</th>
                                                                    <th scope="col">Weight</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template
                                                    v-for="(
                                                        delivery, index
                                                    ) in shipment_detail.shippers"
                                                >
                                                    <tr>
                                                        
                                                        <td>
                                                            {{
                                                                delivery.hbl_num
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                shipment_detail
                                                                    .containers[
                                                                    index
                                                                ].size
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                delivery.cargoDetails
                                                                    ? delivery
                                                                          .cargoDetails
                                                                          .total_volume
                                                                    : ""
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                delivery.cargoDetails
                                                                    ? delivery
                                                                          .cargoDetails
                                                                          .total_weight
                                                                    : ""
                                                            }}
                                                        </td>
                                                    </tr>
                                                </template>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-pane" id="arrow-iteminfo" role="tabpanel">
                                                <div class="card-header header-custom-padding mb-2 p-0 border-0">
                                                    <div class="row g-0">
                                                        <div class="col-6 col-sm-3 border border-dashed">
                                                            <div class="py-12">
                                                                <p class="mb-0"><span class="fw-semibold color-h">Order Number:</span>
                                                                
                                                                <span class="color-h">
                                                                    <template v-if="order != null">
                                                                        {{ order.order.order_number }}
                                                                    </template>
                                                                </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <!--end col-->
                                                        <div class="col-6 col-sm-3 border border-dashed border-start-0">
                                                            <div class="py-12">
                                                                <p class="mb-0"><span class="fw-semibold color-h">Date:</span> 
                                                                    <span class="color-h">
                                                                    <template v-if="order != null">
                                                                        {{ order.created_at_date }}
                                                                    </template>
                                                                   
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <!--end col-->
                                                        <div class="col-6 col-sm-3 border border-dashed border-start-0">
                                                            <div class="py-12">
                                                                <p class="mb-0"><span class="fw-semibold color-h">Customer:</span> 
                                                                    <span class="color-h">
                                                                    <template v-if="order != null">
                                                                        {{
                                                                        order.order.customer
                                                                            ? order.order
                                                                                .customer
                                                                                .company_name
                                                                            : ""
                                                                    }}
                                                                    </template>
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <!--end col-->
                                                        <div class="col-6 col-sm-3 border border-dashed border-start-0">
                                                            <div class="py-12">
                                                                <p class="mb-0"><span class="fw-semibold color-h">Vendor:</span> 
                                                                <span class="color-h">
                                                                <template v-if="order != null">
                                                                    {{
                                                                    order.vendor
                                                                    ? order.vendor
                                                                        .company_name
                                                                    : ""}}
                                                                </template>
                                                                </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <!--end col-->
                                                    </div>
                                                </div>
                                                <div class="table-responsive table-card m-0">
                                                    <table class="table table-bordered align-start mb-0">
                                                        <thead class="table-light text-muted">
                                                            <tr>
                                                                <th scope="col">SKU</th>
                                                                <th scope="col">Description</th>
                                                                <th scope="col">UOM</th>
                                                                <th scope="col">Ordered Units</th>
                                                                <th scope="col">Shipped Units</th>
                                                                <th scope="col">Cost</th>
                                                                <th scope="col">Cartons</th>
                                                                <th scope="col">Pallets</th>
                                                                <th scope="col"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                             <template
                                                    v-if="
                                                        shippingProducts != null
                                                    "
                                                >
                                                    <template
                                                        v-for="(
                                                            product, index
                                                        ) in shippingProducts.products"
                                                    >
                                                        <tr>
                                                            <td>
                                                                {{
                                                                    product.sku
                                                                }}
                                                            </td>
                                                            <td
                                                                v-html="
                                                                    product.product_desc
                                                                "
                                                            ></td>
                                                            <td>
                                                                {{
                                                                    product.qty_unit.name
                                                                }}

                                                                
                                                            </td>
                                                            <td>
                                                            <template v-if="product.qty_unit.id == 7 || product.qty_unit.id == 8">
                                                            {{ numberWithCommas(product.quantity * 1000) }}
                                                            </template>
                                                            <template v-else>
                                                            {{  product.quantity }}
                                                            </template>
                                                                
                                                            </td>
                                                            <td>

                                                            <template v-if="product.qty_unit.id == 7 || product.qty_unit.id == 8">
                                                            {{ numberWithCommas(product.pivot.quantity) }}
                                                            </template>
                                                            <template v-else>
                                                            {{  product.pivot.quantity }}
                                                            </template>

                                                                 
                                                            </td>
                                                            <td>${{ product.cost }}</td>
                                                            <td>{{ product.pivot.total_cases }}</td>
                                                            <td>{{ product.pivot.amount_pallet }}</td>
                                                            <td>
                                                            <!-- <a v-on:click="changeEditModeProduct(true,index)" class="btn btn-secondary" href="javascript:void(0);"><i data-v-26877d14="" class="ri-edit-box-line me-1"></i></a> -->
                                                            <a href="javascript:void(0);" v-on:click="changeEditModeProduct(true,index)" class="btn btn-sm btn-primary" ><i class="ri-edit-line"></i></a>
                                                            
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </template>

                                                <template
                                                    v-if="
                                                        shippingProducts != null
                                                    "
                                                >
                                                    <template
                                                        v-for="(
                                                            product, index
                                                        ) in shippingProducts.products"
                                                    >
                                                        <tr class="fw-semibold bg-light">
                                                            <td colspan="3" class="text-end">Total</td>
                                                            <td>
                                                                {{
                                                                    product.quantity
                                                                }}
                                                            </td>
                                                            <td>
                                                                {{
                                                                    product
                                                                        .pivot
                                                                        .quantity
                                                                }}
                                                            </td>
                                                            
                                                             <td>{{ product.pivot.total_cases }}</td>
                                                            <td>{{ product.pivot.amount_pallet }}</td>
                                                             <td>
                                                                {{
                                                                    product
                                                                        .pivot
                                                                        .quantity
                                                                }}
                                                            </td>
                                                            <td></td>
                                                            <!--<td><a v-on:click="changeEditModeProduct(true,index)" class="btn btn-secondary" href="javascript:void(0);"><i data-v-26877d14="" class="ri-edit-box-line me-1"></i></a></td> -->
                                                        </tr>
                                                    </template>
                                                </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                
                                                
                                                
                                            </div>
                                            <div class="tab-pane" id="arrow-docs" role="tabpanel">
                                                <div class="d-flex justify-content-between align-items-center mb-2">
                                                    <h5 class="card-title mb-0 fw-semibold">Documents</h5>
                                                    <button class="btn btn-sm btn-primary fs-13" data-toggle="modal" data-target="#newDocsModal"><i class="ri-add-line align-middle fs-14 me-1"></i>New Document</button>
                                                </div>
                                                <div class="table-responsive table-card m-0">
                                                    <table class="table table-bordered align-middle mb-0">
                                                        <thead class="table-light text-muted">
                                                            <tr>
                                                                <th scope="col">Document Name</th>
                                                                <th scope="col">File</th>
                                                                <th scope="col">Note</th>
                                                                <th scope="col">Created</th>
                                                                <th scope="col"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            

                                                             <template
                                                    v-for="(
                                                        product, index
                                                    ) in shippingDocument"
                                                >
                                                    <tr>
                                                        <td>
                                                            {{ product.name }}
                                                        </td>
                                                        <td>
                                                        <template v-if="product.extension == 'jpg' || product.extension == 'jpeg' || product.extension == 'png' || product.extension == 'gif'  ">
                                                            <a class="lightbox" href="javascript:void(0)" @click="imagePreview(product.file)">
                                                                    <img :src="product.file"
                                                                        style="width: 40px;height: 32px;">
                                                                </a>
                                                        <a  href="javascript:void(0)" v-on:click="downloadWithAxios(product.file,product.file_name)"
                                                                class=" download-btn" style="font-size:18px;"> <i class="ri-download-2-line"></i></a>
                                                        </template>
                                                        <template v-else>
                                                        <!-- <a class="lightbox" href="javascript:void(0)" @click="imagePreview(product.file)"> -->
                                                                    <span class="file-option-icon"><i :class="getFileIconForAttachment(product)"></i></span>
                                                                <!-- </a> -->
                                                        <a  href="javascript:void(0)" v-on:click="downloadWithAxios(product.file,product.file_name)"
                                                                class=" download-btn" style="font-size:18px;"> <i class="ri-download-2-line"></i></a>
                                                        </template>
                                                        
                                                        
                                                        
                                                        
                                                        </td>
                                                        <td>{{product.note}}</td>
                                                        <td>
                                                            {{ formatDate(product.created_at) }}
                                                        </td>
                                                        <td><button class="btn btn-sm btn-danger" @click="removeDocumentItem(product.id)"><i class="ri-delete-bin-line"></i></button></td>
                                                    </tr>
                                                </template>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="tab-pane" id="arrow-bills" role="tabpanel">
                                                <div class="d-flex justify-content-between align-items-center mb-2">
                                                    <h5 class="card-title mb-0 fw-semibold">Bills</h5>
                                                    <button class="btn btn-sm btn-primary fs-13" data-toggle="modal" data-target="#newBillModal"><i class="ri-add-line align-middle fs-14 me-1"></i>New Bill</button>
                                                </div>
                                                <div class="table-responsive table-card m-0">
                                                    <table class="table table-bordered align-middle mb-0">
                                                        <thead class="table-light text-muted">
                                                            <tr>
                                                                <th scope="col">Bill Name</th>
                                                                <th scope="col">File</th>
                                                                <th scope="col">Amount</th>
                                                                <th scope="col">Note</th>
                                                                <th scope="col">Created</th>
                                                                <th scope="col"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            

                                                            <template
                                                    v-for="(
                                                        product, index
                                                    ) in shippingDocumentBill"
                                                >
                                                    <tr>
                                                        <td>
                                                            {{ product.name }}
                                                        </td>
                                                        <td>
                                                        <template v-if="product.extension == 'jpg' || product.extension == 'jpeg' || product.extension == 'png' || product.extension == 'gif'  ">
                                                            <a class="lightbox" href="javascript:void(0)" @click="imagePreview(product.file)">
                                                                    <img :src="product.file"
                                                                        style="width: 40px;height: 32px;">
                                                                </a>
                                                        <a  href="javascript:void(0)" v-on:click="downloadWithAxios(product.file,product.file_name)"
                                                                class=" download-btn" style="font-size:18px;"> <i class="ri-download-2-line"></i></a>
                                                        </template>
                                                        <template v-else>
                                                        <!-- <a class="lightbox" href="javascript:void(0)" @click="imagePreview(product.file)"> -->
                                                                    <span class="file-option-icon"><i :class="getFileIconForAttachment(product)"></i></span>
                                                                <!-- </a> -->
                                                        <a  href="javascript:void(0)" v-on:click="downloadWithAxios(product.file,product.file_name)"
                                                                class=" download-btn" style="font-size:18px;"> <i class="ri-download-2-line"></i></a>
                                                        </template>
                                                        </td>
                                                        <td>
                                                            ${{ product.amount }}
                                                        </td>
                                                        <td>
                                                            {{ product.note }}
                                                        </td>
                                                        <td>
                                                            {{ formatDate(product.created_at) }}
                                                        </td>
                                                        <td><button class="btn btn-sm btn-danger" @click="removeBillItem(product.id)"><i class="ri-delete-bin-line"></i></button></td>
                                                    </tr>
                                                </template>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                <!-- New Html ends here  -->
                    
                </div>

                <div class="col-sm-3 col-md-3 col-xxl-2">
                    <div class="rightcolumn-custom">
                        <template v-if="shippingData != null">
                        <div class="card">
                                    <div class="card-body">
                                        <div class="two-header">
                                            <h5 class="card-title mb-0 pb-1">Shipment Status</h5>
                                        </div>
                                        <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                                            <div class="vertical-progress">
                                                <div class="profile-timeline">
                                                    <div class="accordion accordion-flush">
                                                        <div class="accordion-item  border-0 pb-4"
                                                        :class="{
                                                                active: shippingData.status == 1,
                                                                active: shippingData.status > 1,
                                                            }"
                                                        >
                                                            <div class="accordion-header">
                                                                <a class="accordion-button p-0 shadow-none">
                                                                    <div class="d-flex align-items-center">

                                                                        <template v-if="shippingData.status == 1 || shippingData.status > 1">
                                                                            <div class="flex-shrink-0 avatar-xs">
                                                                            
                                                                                <div class="avatar-title bg-success rounded-circle">
                                                                                    1
                                                                                </div>
                                                                            </div>
                                                                            <div class="flex-grow-1 ms-2">
                                                                                <h6 class="fs-14 mb-0 fw-medium text-success">Not initiated</h6>
                                                                            </div>
                                                                        </template>
                                                                        <template v-else>
                                                                            
                                                                            <div class="d-flex align-items-center">
                                                                                <div class="flex-shrink-0 avatar-xs">
                                                                                    <div class="avatar-title bg-light text-dark rounded-circle">
                                                                                        1
                                                                                    </div>
                                                                                </div>
                                                                                <div class="flex-grow-1 ms-2">
                                                                                    <h6 class="fs-14 mb-1 fw-medium">Not initiated</h6>
                                                                                </div>
                                                                            </div>
                                                                                    
                                                                        </template>

                                                                        
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        
                                                        <div class="accordion-item  border-0 pb-4"
                                                             :class="{
                                                                active: shippingData.status == 2,
                                                                active: shippingData.status > 2,
                                                            }"
                                                        >
                                                            <div class="accordion-header">
                                                                <a class="accordion-button p-0 shadow-none">
                                                                    <div class="d-flex align-items-center">

                                                                        <template v-if="shippingData.status == 2 || shippingData.status > 2">
                                                                            <div class="flex-shrink-0 avatar-xs">
                                                                            
                                                                                <div class="avatar-title bg-success rounded-circle">
                                                                                    2
                                                                                </div>
                                                                            </div>
                                                                            <div class="flex-grow-1 ms-2">
                                                                                <h6 class="fs-14 mb-0 fw-medium text-success">Shipped</h6>
                                                                            </div>
                                                                        </template>
                                                                        <template v-else>
                                                                            
                                                                            <div class="d-flex align-items-center">
                                                                                <div class="flex-shrink-0 avatar-xs">
                                                                                    <div class="avatar-title bg-light text-dark rounded-circle">
                                                                                        2
                                                                                    </div>
                                                                                </div>
                                                                                <div class="flex-grow-1 ms-2">
                                                                                    <h6 class="fs-14 mb-1 fw-medium">Shipped</h6>
                                                                                </div>
                                                                            </div>
                                                                                    
                                                                        </template>

                                                                        
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>

                                                        <div class="accordion-item  border-0 pb-4"
                                                         :class="{
                                                                active: shippingData.status == 3,
                                                                active: shippingData.status > 3,
                                                            }"
                                                        >
                                                            <div class="accordion-header">
                                                                <a class="accordion-button p-0 shadow-none">
                                                                    <div class="d-flex align-items-center">

                                                                        <template v-if="shippingData.status == 3 || shippingData.status > 3">
                                                                            <div class="flex-shrink-0 avatar-xs">
                                                                            
                                                                                <div class="avatar-title bg-success rounded-circle">
                                                                                    3
                                                                                </div>
                                                                            </div>
                                                                            <div class="flex-grow-1 ms-2">
                                                                                <h6 class="fs-14 mb-0 fw-medium text-success">In Transit</h6>
                                                                            </div>
                                                                        </template>
                                                                        <template v-else>
                                                                            
                                                                            <div class="d-flex align-items-center">
                                                                                <div class="flex-shrink-0 avatar-xs">
                                                                                    <div class="avatar-title bg-light text-dark rounded-circle">
                                                                                        3
                                                                                    </div>
                                                                                </div>
                                                                                <div class="flex-grow-1 ms-2">
                                                                                    <h6 class="fs-14 mb-1 fw-medium">In Transit</h6>
                                                                                </div>
                                                                            </div>
                                                                                    
                                                                        </template>

                                                                        
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>


                                                        <div class="accordion-item  border-0 pb-4"
                                                         :class="{
                                                                active: shippingData.status == 4,
                                                                active: shippingData.status > 4,
                                                            }"
                                                        >
                                                            <div class="accordion-header">
                                                                <a class="accordion-button p-0 shadow-none">
                                                                    <div class="d-flex align-items-center">

                                                                        <template v-if="shippingData.status == 4 || shippingData.status > 4">
                                                                            <div class="flex-shrink-0 avatar-xs">
                                                                            
                                                                                <div class="avatar-title bg-success rounded-circle">
                                                                                    4
                                                                                </div>
                                                                            </div>
                                                                            <div class="flex-grow-1 ms-2">
                                                                                <h6 class="fs-14 mb-0 fw-medium text-success">Delivered</h6>
                                                                            </div>
                                                                        </template>
                                                                        <template v-else>
                                                                            
                                                                            <div class="d-flex align-items-center">
                                                                                <div class="flex-shrink-0 avatar-xs">
                                                                                    <div class="avatar-title bg-light text-dark rounded-circle">
                                                                                        4
                                                                                    </div>
                                                                                </div>
                                                                                <div class="flex-grow-1 ms-2">
                                                                                    <h6 class="fs-14 mb-1 fw-medium">Delivered</h6>
                                                                                </div>
                                                                            </div>
                                                                                    
                                                                        </template>

                                                                        
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        
                                                        
                                                    </div>
                                                    <!--end accordion-->
                                                </div>
                                            </div>  
                                        </div>
                                    </div>
                                </div>

                                </template>
                        <div class="card">
                            <div class="right-header2">
                                <div class="card-header">
                                    <h5 class="card-title flex-grow-1 mb-0">
                                        Milestones 
                                    </h5>
                                </div>

                                <Milestones
                                    :shipmentDetails="milestone"
                                    :order="order"
                                    :is-edit-mode="isEditMode"
                                    :loading="loading"
                                ></Milestones>

                                <!-- <div class="card-body2">
                                    <div class="list-containerbox">
                                        <div class="listDetails"></div>
                                    </div>
                                </div> -->
                            </div>
                            <!--<a href="javascript:void(0)" class="newBtn" v-on:click="goToCreateCustomer"> New Customer</a>-->

                            <!-- <div class="shiping-details">
                                <Milestones
                                    :shipmentDetails="shipment_detail"
                                    :order="order"
                                    :is-edit-mode="isEditMode"
                                    :loading="loading"
                                ></Milestones>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- The Modal -->

        <LightBox
            :media="previewMedia"
            :showLightBox="false"
            :showThumbs="false"
            ref="lightbox"
        ></LightBox>


        <!-- New Document Modal -->
                <div class="modal fade" id="newDocsModal" tabindex="-1" aria-labelledby="newDocsModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content border-0">
                            <div class="modal-header p-3 bg-soft-info">
                                <h5 class="modal-title" id="newDocsModalLabel">Add New Document</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body form-steps">

                            <ValidationObserver v-slot="{handleSubmit,}" ref="formValidation">
                                <form  @submit.prevent="handleSubmit(submitHandler)" enctype="multipart/form-data">


                             
                                <div class="mb-3">
                                    <label>Document Name</label>
                                    <ValidationProvider
                                        name="document_name"
                                        rules="required"
                                        v-slot="{
                                            errors,
                                        }"
                                    >
                                    

                                    <input
                                    class="form-control"
                                            type="text"
                                            name="document_name"
                                            v-model="document_name"
                                            
                                        />
                                        <div
                                            class="error"
                                            v-if="
                                                errors.length
                                            "
                                        >
                                            {{
                                                errors[0]
                                            }}
                                        </div>

                                    </ValidationProvider>
                                    
                                </div>
                                <div class="mb-3">
                                    <label>Document</label>

                                    <ValidationProvider
                                        name="document_file"
                                        rules="required"
                                        v-slot="{ validate, errors }"
                                    >
                                        <input
                                        class="form-control"
                                            type="file"
                                            name="document_file"
                                                        
                                            @change="handleFileChange($event) || validate($event)"
                                        />
                                            <div
                                            class="error"
                                            v-if="
                                                errors.length
                                            "
                                        >
                                            {{
                                                errors[0]
                                            }}
                                        </div>
                                    </ValidationProvider>

                                    
                                </div>
                                <div class="mb-3">
                                    <label>Note</label>
                                    <input type="" name="" v-model="note" class="form-control" value="">
                                </div>

                                <div class="pt-1 text-end">
                                    <button class="btn btn-primary me-1 w-md" type="submit">Upload</button>
                                    <button class="btn btn-danger" data-dismiss="modal" aria-label="Close">Cancel</button>
                                </div>
                                </form>
                            </ValidationObserver>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End New Document Modal -->

                <!-- New Bill Modal -->
                <div class="modal fade" id="newBillModal" tabindex="-1" aria-labelledby="newBillModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content border-0">
                            <div class="modal-header p-3 bg-soft-info">
                                <h5 class="modal-title" id="newBillModalLabel">Add New Bill</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body form-steps">

                            <ValidationObserver
                                    v-slot="{
                                        handleSubmit,
                                    }" 
                                    ref="formValidation" 
                                >
                                    <form
                                        @submit.prevent="
                                            handleSubmit(
                                                submitHandlerBill
                                            )
                                        "
                                        enctype="multipart/form-data"
                                    >

                                <div class="mb-3">
                                    <label>Bill Name</label>
                                    <ValidationProvider
                                        name="bill_document_name"
                                        rules="required"
                                        v-slot="{
                                            errors,
                                        }"
                                    >
                                        <input
                                        class="form-control"
                                            type="text"
                                            name="bill_document_name"
                                            v-model="bill_document_name"
                                            
                                        />
                                        <div
                                            class="error"
                                            v-if="
                                                errors.length
                                            "
                                        >
                                            {{
                                                errors[0]
                                            }}
                                        </div>
                                    </ValidationProvider>

                                    
                                </div>
                                <div class="mb-3">
                                    <label>Bill Amount</label>
                                     <ValidationProvider
                                            name="bill_document_amount"
                                            rules="required|numeric"
                                            v-slot="{
                                                errors,
                                            }"
                                        >
                                            <input
                                                type="text"
                                                class="form-control"
                                                name="bill_document_amount"
                                                v-model="bill_document_amount"
                                                
                                            />
                                            <div
                                                class="error"
                                                v-if="
                                                    errors.length
                                                "
                                            >
                                                {{
                                                    errors[0]
                                                }}
                                            </div>
                                        </ValidationProvider>
                                        
                                    
                                </div>
                                <div class="mb-3">
                                    <label>File</label>
                                   
                                    
                                    <ValidationProvider
                                        name="bill_document_file"
                                        rules="required"
                                        v-slot="{ validate, errors }"
                                    >
                                        <input
                                            type="file"
                                            name="bill_document_file"
                                             class="form-control"           
                                            @change="handleFileChangeBill($event) || validate($event)"
                                        />
                                            <div
                                            class="error"
                                            v-if="
                                                errors.length
                                            "
                                        >
                                            {{
                                                errors[0]
                                            }}
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="mb-3">
                                    <label>Note</label>
                                    <input type="" name="" v-model="bill_note" class="form-control" value="">
                                </div>

                                <div class="pt-1 text-end">
                                    <button class="btn btn-primary me-1 w-md" type="submit">Upload</button>
                                    <button class="btn btn-danger" data-dismiss="modal" aria-label="Close">Cancel</button>
                                </div>
                                </form>
                                </ValidationObserver>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End New Bill Modal -->


                <!-- Edit Shipment Info Modal -->
                <div class="modal fade" id="editShipmentInfoModal" tabindex="-1" aria-labelledby="editShipmentInfoModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content border-0">
                            <div class="modal-header p-3 bg-soft-info">
                                <h5 class="modal-title" id="editShipmentInfoModalLabel">Edit Shipment Info</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body form-steps">

                            <template v-if="shippingData != null">
                                <div class="row">
                                    <div class="col-6 mb-3">
                                        <label>MBL</label>
                                        <input type="" name="" v-model="shippingData.tracking_no" class="form-control" >
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Shipping Method</label>
                                        <div>

                                        <select
                                            class="form-select"
                                            v-model="shippingData.carrier_type"
                                        >
                                            <!-- <option value="3">Partial By Air – Air</option>
                                            <option value="1">Full order by air</option>
                                            <option value="2">Full Shipment by Sea</option> -->
                                            <option value="1">Air</option>
                                            <option value="2">
                                                Occean
                                            </option>
                                        </select>

                                            
                                        </div>
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Eta</label>
                                        <date-picker
                                            v-model="shippingData.eta_arrival"
                                            valueType="format"
                                        ></date-picker>
                                        <!-- <input type="date" name="" class="form-control" v-model="shippingData.eta_arrival"> -->
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Etd</label>
                                        <date-picker
                                                                    v-model="shippingData.eta_departure"
                                                                    valueType="format"
                                                                ></date-picker>
                                    </div>
                                    <div class="col-12 mb-3">
                                        <label>Ship to</label>
                                        <textarea
                                                                    class="form-control"
                                                                    style="height: 80px"
                                                                    v-model="shippingData.destination"
                                                                ></textarea>

                                        <!-- <div class="mb-2" style="max-width: 170px">
                                            <select class="form-select">
                                                <option value="0">Select a Address</option>
                                                <option value="1">Jakkuru</option>
                                                <option value="2">Salt Lake</option>
                                            </select>
                                        </div> -->
                                        <!-- <textarea type="" name="" class="form-control">ST45, Brad street, Newyork, NY, NYPD564</textarea> -->
                                    </div>

                                    <div class="col-6 mb-3">
                                        <label>Superb Warehouse</label>
                                        <v-select
                                                label="name"
                                                :filterable="true"
                                                v-model="form.company_warehouse"
                                                :options="companyWarehouse"
                                                :reduce="
                                                    (option) => option.id
                                                "
                                            >
                                                <template slot="no-options">
                                                    type to search carrier..
                                                </template>
                                                <template
                                                    slot="option"
                                                    slot-scope="option"
                                                >
                                                    <div
                                                        class="d-center"
                                                        v-html="option.address"
                                                    ></div>
                                                </template>
                                                <template
                                                    slot="selected-option"
                                                    slot-scope="option"
                                                >
                                                    <div
                                                        class="selected d-center"
                                                        v-html="option.address"
                                                    ></div>
                                                </template>
                                            </v-select>
                                    </div>

                                </div>

                                </template>

                                <div class="mt-2 text-end">
                                    <button class="btn btn-primary me-1 w-md" @click="saveShipingDetails">Save</button>
                                    <button class="btn btn-danger" data-dismiss="modal" aria-label="Close">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Edit Shipment Info Modal -->


                <!-- Edit Item Info Modal -->
                <div class="modal fade" id="editItemInfoModal" tabindex="-1" aria-labelledby="editItemInfoModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content border-0">
                            <div class="modal-header p-3 bg-soft-info">
                                <h5 class="modal-title" id="editItemInfoModalLabel">Edit Item Info</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body form-steps">
                                <div class="row">
                                    <div class="col-6 mb-3">
                                        <label>Shipped Units</label>
                                        <input type="" name="" class="form-control" v-model="product_form.shipped_units" >
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Pcs Per Case</label>
                                        <input type="" name="" @input="checkCaseNumber()"
                                                                        v-model="product_form.pcs_per_case" class="form-control" >
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Cases Per pallet</label>
                                        <input type="" name=""  @input="checkCaseNumber()"
                                                                       v-model="product_form.cases_per_pallet" class="form-control" >
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Amount of Case</label>
                                        <input type="" v-model="product_form.total_cases" name="" class="form-control">
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Amount Of pallet</label>
                                        <input type="" name="" v-model="product_form.total_cases" class="form-control" >
                                    </div>
                                </div>

                                <div class="mt-3 text-end">
                                    <button class="btn btn-primary me-1 w-md" @click="saveShipingProductDetails">Save</button>
                                    <button class="btn btn-danger" data-dismiss="modal" aria-label="Close">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Edit Item Info Modal -->


        <footer class="footer">
            <div class="dropzone-previews custom-dropzone-preview"></div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">2022 © Superb.</div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import ProductArtworksModal from "../../components/ProductArtworksModal";
import OrderExtraChargeModal from "../../components/OrderExtraChargeModal";
import Vue from "vue";
import {
    ValidationProvider,
    ValidationObserver,
    extend,
    configure,
} from "vee-validate";
import LightBox from "vue-it-bigger";
import PurchaseOrderDiscountModal from "../../components/PurchaseOrderDiscountModal";
import PurchaseOrderExtraChargeModal from "../../components/PurchaseOrderExtraChargeModal";
import SendPurchaseOrderToVendor from "../../components/SendPurchaseOrderToVendor";
import SendProductArtworkToCustomer from "../../components/SendProductArtworkToCustomer";
import ProductArtworkVersionsModal from "../../components/ProductArtworkVersionsModal";
import VendorAddModal from "../../components/VendorAddModal";
import AllProductsArtworkVersionsModal from "../../components/AllProductsArtworkVersionsModal";
import ArtworkCommentModal from "../../components/ArtworkCommentModal";
import SendProductArtworkToVendor from "../../components/SendProductArtworkToVendor";
import OrderTask from "../../components/OrderTask";
import AddTask from "../../components/AddTask";
import OrderShipping from "../../components/OrderShipping";
import AddShippingModal from "../../components/AddShippingModal";
import OrderShipments from "../../components/OrderShipments";
import OrderShipmentData from "../../components/OrderShipmentData";
import OrderDatesModal from "../../components/OrderDatesModal";
import CheckAirFreightModal from "../../components/CheckAirFreightModal";
import Milestones from "../../components/Milestones";

configure({
    classes: {
        valid: "is-valid",
        invalid: "is-invalid",
        dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
        // ...
    },
});

extend("positive", (value) => {
    if (value >= 0) {
        return true;
    }

    return "This field must be a positive number";
});

export default {
    name: "PurchaseOrderShow",
    components: {
        OrderShipmentData,
        DatePicker,
        vueDropzone: vue2Dropzone,
        ProductArtworksModal,
        ValidationObserver,
        ValidationProvider,
        PurchaseOrderDiscountModal,
        PurchaseOrderExtraChargeModal,
        SendPurchaseOrderToVendor,
        SendProductArtworkToCustomer,
        ProductArtworkVersionsModal,
        LightBox,
        VendorAddModal,
        AllProductsArtworkVersionsModal,
        ArtworkCommentModal,
        SendProductArtworkToVendor,
        OrderTask,
        AddTask,
        OrderShipping,
        AddShippingModal,
        OrderShipments,
        OrderDatesModal,
        CheckAirFreightModal,
        Milestones,
    },
    created() {
        // this.getOrderStatuses();
        //this.getQuantityUnits();
        this.getOrder();
        this.getShippingProducts();
        this.getShippingDocument();
        this.getShippingDocumentBill();
        
    },
    mounted() {
        let self = this;
        //this.getDueTasks();
        //this.getShippings();
        this.getShipping();
        $("#addTaskModal").on("hidden.bs.modal", function () {
            self.task = null;
        });
    },
    data() {
        return {
            milestone:{
                milestones:[],
                upcoming_milestone:[]
            },
             companyWarehouse:[],
            customerWarehouse:[],
            shippingTypeOptions: [],
            product_form:{
                purchase_order_product_id:null,
                id:null,
                pivot_id:null,
                ship_id:this.$route.params.shipId,
                purchase_order_id:this.$route.params.id,
                shipped_units:null,
                pcs_per_case:null,
                cases_per_pallet:null,
                total_cases:null,
                amount_pallet:null,
            },
            form: {
                shipping_number: null,
                eta: null,
                etd: null,
                order_id: null,
                customer: null,
                customer_id: null,
                carrier_id: null,
                vendor: null,
                vendor_id: null,
                purchase_order_id: null,
                source: null,
                destination: null,
                shipment_type: null,
                products: [],
                carrier_type: null,
                shipping_type: null,
                carrier_company: null,
                status: 1,
                tracking_no: null,
                tracking_url: null,
                completed_at: null,
                eta_departure: null,
                eta_arrival: null,
                notes: null,
                tracking_no:null,
                is_partially_shipped: false,
            },

            shippingDocument:[],
            shippingDocumentBill:[],

            bill_document_name:null,
            bill_document_file:null,
            bill_document_amount:null,
            document_name:null,
            note:"",
            bill_note:"",
            document_file:null,
            shipmentDetails: [],
            shipment_detail: {
                shippers: [],
            },
            shippingProducts: {
                products: [],
            },
            showShimpment: false,
            shippingData: null,
            shipmentId: null,
            bus: new Vue(),
            task: null,
            order: null,
            product: null,
            artwork: null,
            charge: null,
            isEditMode: false,
            isEditModeProduct:false,
            statuses: [],
            salesReps: [],
            quantityUnits: [],
            vendorSearch: null,
            shipSearch: null,
            customerSearch: null,
            customerPayment: {
                payment_date: null,
                status: null,
                amount: null,
                percentage: null,
            },
            attachments: [],
            customerAttachments: [],
            submitted: false,
            sub_total_cost: 0,
            dropzoneOptions: {
                url: window.route("medias.store"),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 1,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "X-CSRF-TOKEN":
                        document.head.querySelector("[name=csrf-token]")
                            .content,
                },
            },
            dropzoneOptionsArtwork: {
                url: window.route("medias.store"),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 1,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                acceptedFiles: "image/*,application/pdf",
                disablePreviews: true,
                previewsContainer: ".custom-dropzone-preview",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "X-CSRF-TOKEN":
                        document.head.querySelector("[name=csrf-token]")
                            .content,
                },
            },
            dropzoneOptionsOriginalFile: {
                url: window.route("medias.store"),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 1,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                disablePreviews: true,
                previewsContainer: ".custom-dropzone-preview",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "X-CSRF-TOKEN":
                        document.head.querySelector("[name=csrf-token]")
                            .content,
                },
            },
            noteMessage: null,
            order_note: null,
            purchase_orders: [],
            editorConfig: {},
            editorConfigMin: {
                toolbar: [
                    ["Source", "-", "Bold", "Italic"],
                    ["Styles", "Format", "Font", "FontSize"],
                ],
            },
            artwork_statuses: [],
            previewMedia: [],
            productExtendedView: false,
            eachProductsHasArtwork: false,
            is_one_artwork_for_all: false,
            isChangeStatusForAllArtworks: true,
            targetArtwork: null,
            admin_users: [],
            dueTasks: [],
            shipping: null,
            //shippingProducts: null,
            shippingProductDetailId: null,
            dateType: null,
            validationErrors: null,
            isEditLabelSection: false,
            newLabelId: [],
            labels: [],
        };
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
            "setNewPurchaseOrder",
            "backShipmentState"
        ]),

        downloadExcel(id) {
            console.log("d  this.order",this.order);
            let param = {
                id: 1, 
                shipment_detail:this.shipment_detail,
                final_destination:this.shippingData.final_destination,
                vendor: this.order.vendor
            }
            let url = window.route("po.exportFile", param);

            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            axios({
                url: url,
                method: "GET",
                responseType: "blob"
            })
            .then((response) => {
                this.setLoading(false);

                // Get filename from headers (Laravel Excel)
                let filename = "export.xlsx";
                const disposition = response.headers["content-disposition"];
                if (disposition && disposition.indexOf("filename=") !== -1) {
                    filename = disposition
                        .split("filename=")[1]
                        .replace(/"/g, "");
                }

                // Create blob URL
                const blob = new Blob([response.data]);
                const downloadUrl = window.URL.createObjectURL(blob);

                // Create link
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();

                // Cleanup
                link.remove();
                window.URL.revokeObjectURL(downloadUrl);
            })
            .catch((error) => {
                this.setErrorMessage(
                    error.response && error.response.data?.message
                        ? error.response.data.message
                        : error.message
                );
            })
            .finally(() => {
                this.setLoading(false);
            });

        },

        getCompanyWarehouse() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("getWarehouses.company", {}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        console.log("company warehouse ",data);
                        this.companyWarehouse = data.data;
                        //this.statuses = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },

        getCustomerWarehouse() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("getWarehouses.customer", {customer_id:this.order.order.customer_id}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerWarehouse = data.data;
                         console.log("customer warehouse ",data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        backTo(){
            this.backShipmentState(true);
            this.$router.go(-1);
        },
        saveShipingProductDetails(){
            
            
             let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.updateShippingProductDetails"),
                    this.product_form,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.isEditMode = false;
                        this.isEditModeProduct = false;
                        $("#editItemInfoModal").modal("hide");
                        self.setSuccessMessage(data.data);
                        this.getOrder();
                        this.getShippingProducts();
                        this.getShippingDocument();
                        this.getShippingDocumentBill();

                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        //this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });

        },
        saveShipingDetails(){
            console.log("shippingData ",this.shippingData)
             let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.updateShippingDetails", {
                        id: this.$route.params.shipId,
                    }),
                    this.shippingData,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {

                        $("#editShipmentInfoModal").modal("hide");
                        this.isEditMode = false;
                        this.isEditModeProduct = false;
                        self.setSuccessMessage(data.data);
                        this.getOrder();
                        this.getShippingProducts();
                        this.getShippingDocument();
                        this.getShippingDocumentBill();

                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        //this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        checkCaseNumber() {
            
            //console.log('this.product_form',this.product_form);
            if(this.product_form.pcs_per_case != '' && this.product_form.cases_per_pallet){
                this.product_form.total_cases = Math.ceil(this.product_form.shipped_units / (this.product_form.pcs_per_case));
                this.product_form.amount_pallet = this.product_form.total_cases / this.product_form.cases_per_pallet;
            }
            
           
        },

         getFileIconForAttachment(attachment) {
            // ri-folder-zip-line, ri-file-ppt-2-line, bx bxs-file-pdf, bx bxs-file-doc, bx bx-image-alt
            //console.log(attachment.file_name.toLowerCase())
            if(attachment.file.toLowerCase().includes(".pdf")) {
                return 'fas fa-file-pdf';
            } else if(attachment.file.toLowerCase().includes(".doc")) {
                return 'fas fa-file-word';
            } else if(attachment.file.toLowerCase().includes(".docx")) {
                return 'fas fa-file-word';
            } else if(attachment.file.toLowerCase().includes(".xlx")) {
                return 'fas fa-file-word';
            } else if(attachment.file.toLowerCase().includes(".xlsx")) {
                return 'fas fa-file-word';
            } else if(attachment.file.toLowerCase().includes(".ppt")) {
                return 'ri-file-ppt-2-line';
            } else if(attachment.file.toLowerCase().includes(".pptx")) {
                return 'ri-file-ppt-2-line';
            } else if(attachment.file.toLowerCase().includes(".zip") || attachment.file.toLowerCase().includes(".rar") ||
                attachment.file.toLowerCase().includes(".7z") || attachment.file.toLowerCase().includes(".gzip") ||
                attachment.file.toLowerCase().includes(".gz")) {
                return 'ri-folder-zip-line';
            } else {
                return 'fas fa-file-image';
            }
        },
        imagePreview(src, caption = '') {
        console.log("src ",src);
            this.previewMedia = [{
                thumb: src,
                src: src,
                caption: caption, // Optional
                //srcset: '...' // Optional for displaying responsive images
            }];
            this.$refs.lightbox.showImage(0)
        },

        handleFileChangeBill(event){
            this.bill_document_file = event.target.files[0];
        },
        handleFileChange(event){
            this.document_file = event.target.files[0];
        },
        getShippingProducts() {
            console.log("params.shipId ", this.$route.params.shipId);

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("po.shippingProducts", {
                        id: this.$route.params.shipId,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.shippingProducts = data.data;
                        console.log("data Shipping : ", data);
                        // this.shippingProducts = _.cloneDeep(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getShipping() {
            console.log("params.shipId ", this.$route.params.shipId);

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("po.getShppingDetails", {
                        id: this.$route.params.shipId,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.shippingData = data.data;
                        this.form.status = this.shippingData.status;
                        this.form.tracking_no = this.shippingData.tracking_no;
                        if(data.data.shipping_number == null){
                            this.form.shipping_number = data.data.id
                        }
                        else{
                            this.form.shipping_number = data.data.shipping_number

                        }
                        
                        console.log("data Shipping : ", data);
                        // this.shippingProducts = _.cloneDeep(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getShippingDocumentBill(){
            
            console.log("params.shipId ", this.$route.params.shipId);

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("po.shipping-list-bill", {
                        id: this.$route.params.shipId,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.shippingDocumentBill = data.data;
                        console.log("data Shipping : ", data);
                        // this.shippingProducts = _.cloneDeep(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getShippingDocument() {
            console.log("params.shipId ", this.$route.params.shipId);

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("po.shipping-list", {
                        id: this.$route.params.shipId,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.shippingDocument = data.data;
                        console.log("data Shipping : ", data);
                        // this.shippingProducts = _.cloneDeep(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },

        getShippingDetails() {
            console.log("dddddddddddddddddddddd");
            let self = this;
            this.setLoading(false);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.getShppingNumberByMbl", {
                        id: this.$route.params.id,
                    }),
                    { mbl_number: this.shippingData.tracking_no },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        console.log("data shfl shipping number : ", data);
                        this.shipmentDetails = data.data.data;
                        this.shipment_detail = data.shipment_detail;
                        this.milestone = data.milestone;
                        console.log(
                            "this.shipment_detail signle : ",
                            this.shipment_detail
                        );

                        console.log(
                            "this.shipmentDetails : ",
                            this.shipmentDetails
                        );
                        // this.shipmentDetails = data.data.data;
                        // this.showShimpment = true;
                        // this.shipmentId = data.data.data.shipment_id;
                        // console.log("this.shipmentId : ", this.shipmentId);

                        // this.setSuccessMessage(
                        //     "Label added to this order successfully!"
                        // );
                        //this.isEditLabelSection = false;
                        //this.newLabelId = [];
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        //this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        
        shipEditSave() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.shippingEditSave", { id: this.$route.params.shipId }),
                    this.form,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(
                            "Data saved successfully!"
                        );
                        this.isEditMode = false;
                        //this.newLabelId = [];
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.getShipping();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        saveMblNumber() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.addMblNumber", { id: this.order.id }),
                    { mbl_number: this.order.mbl_number },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(
                            "Label added to this order successfully!"
                        );
                        //this.isEditLabelSection = false;
                        //this.newLabelId = [];
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },

        getShippings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("po.getShippings", {
                        id: this.$route.params.id,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.shippingProducts = _.cloneDeep(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        sentPurchaseOrderToVendor() {
            this.getDueTasks();
            this.getOrder();
        },
        depositSent(task) {
            task.deposit_sent_amount = this.order.deposit_sent_amount;
            task.assign_ids = task.admins.map((x) => x.id);
            task.order_id = this.order.id;
            task.order_type = "po";
            task.status = 1;

            let self = this;
            return axios
                .put(
                    window.route("dashboard.tasks.update", { id: task.id }),
                    task,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && Object.keys(data.errors).length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.saveOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        completeTask(id) {
            this.bus.$emit("triggerCompleteTask", id);
        },
        completedEvent() {
            this.bus.$emit("triggerGetTasks");
            this.getDueTasks();
        },
        openTaskEditEvent(task) {
            this.task = _.cloneDeep(task);
            setTimeout(() => {
                $("#addTaskModal").modal("show");
            }, 100);
        },
        taskAddedEvent(event) {
            this.bus.$emit("triggerGetTasks");
            $("#addTaskModal").modal("hide");
        },
        taskUpdatedEvent(event) {
            this.task = null;
            this.bus.$emit("triggerGetTasks");
            $("#addTaskModal").modal("hide");
        },
        sendPOToVendorEvent() {
            $("#sendPOToVendorModal").modal("show");
        },
        getDueTasks() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let url = window.route("po.tasks.due", {
                id: this.$route.params.id,
            });

            return axios
                .get(url, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.dueTasks = _.cloneDeep(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        checkIfFirstRow(product, index, artwork, artworkIndex) {
            if (!product.latest_artwork) {
                return artworkIndex == 0;
            }
            let arts = product.artworks.filter(
                (art) =>
                    art.id == null ||
                    (product.latest_artwork &&
                        art.id == product.latest_artwork.id)
            );
            if (arts.length) {
                return arts[0].id != null && artwork.id == arts[0].id;
            }
            return false;
        },
        artworkStatusChangeForAll(event) {
            if (event.target.value) {
                this.order.products.forEach((product, index) => {
                    if (
                        product.latest_artwork &&
                        !this.isChangeStatusForAllArtworks
                    ) {
                        product.artworks
                            .filter(
                                (x) =>
                                    x.id == null ||
                                    x.id == product.latest_artwork.id
                            )
                            .forEach((artwork, artworkIndex) => {
                                artwork.artwork_status_id = event.target.value;
                            });
                    } else {
                        product.artworks.forEach((artwork, artworkIndex) => {
                            artwork.artwork_status_id = event.target.value;
                        });
                    }
                });
            }
        },
        viewComments(artwork) {
            this.targetArtwork = _.cloneDeep(artwork);
            setTimeout(() => {
                $("#artworkCommentModal").modal("show");
            }, 100);
        },
        vendorEmailSentEvent(event) {
            this.getOrder();
        },
        customerEmailSentEvent(event) {
            this.getOrder();
        },
        vendorDataSaved(vendor) {
            $("#vendorAddModal").modal("hide");
        },
        
        openSendArtworkToCustomer(product, artwork) {
            //this.product = _.cloneDeep(this.order.products.find((x) => x.order_product_id == product.id))
            this.product = _.cloneDeep(product);
            this.artwork = _.cloneDeep(artwork);
            this.is_one_artwork_for_all = true;
            $("#sendProductArtworkToCustomer").modal("show");
        },
        openSendArtworkToVendor(product) {
            this.product = _.cloneDeep(product);
            this.is_one_artwork_for_all = false;
            setTimeout(() => {
                $("#sendProductArtworkToVendor").modal("show");
            }, 50);
        },
        openSendAllArtworkToVendor() {
            this.product = null;
            this.artwork = null;
            this.is_one_artwork_for_all = true;
            $("#sendProductArtworkToVendor").modal("show");
        },
        openSendAllArtworkToCustomer(is_one_artwork_for_all) {
            this.product = null;
            this.artwork = null;
            this.is_one_artwork_for_all = is_one_artwork_for_all;
            $("#sendProductArtworkToCustomer").modal("show");
        },

        
        submitHandlerBill() {
            this.setLoading(true);
            let formData = new FormData();
            
            formData.append('ship_id', this.$route.params.shipId);
            formData.append('document_name', this.bill_document_name);
            formData.append('note', this.bill_note);
            formData.append('amount', this.bill_document_amount);
            formData.append('file', this.bill_document_file);

            axios
                .post(
                    window.route("po.uploadShipDocumentBill"),
                    formData,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        console.log("dddddddddddddddddddddddddddddddddd");
                        this.setSuccessMessage("File uploaded successfully!");
                        $("#newBillModal").modal("hide");
                        this.isEditMode = false;
                        this.getOrder();
                        this.getShippingDocumentBill();
                        setTimeout(() => {
                            this.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    this.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    this.setLoading(false);
                });

            /*this.$refs.formValidation.validate().then(success => {
                if (!success) {
                    return;
                }
                this.saveOrder();
            });*/
            // this.$refs.formValidation.validateWithInfo().then((data) => {
            //     console.log(
            //         "success",
            //         data.isValid,
            //         data.errors,
            //         data.flags,
            //         data.fields
            //     );
            //     this.validationErrors = data;
            //     if (!data.isValid) {
            //         return;
            //     }
            //     this.saveOrder();
            // });
        },

        submitHandler() {
            this.setLoading(true);
            let formData = new FormData();
            
            formData.append('ship_id', this.$route.params.shipId);
            formData.append('document_name', this.document_name);
            formData.append('note', this.note);
            formData.append('file', this.document_file);

            axios
                .post(
                    window.route("po.uploadShipDocument"),
                    formData,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        console.log("dddddddddddddddddddddddddddddddddd");
                        this.setSuccessMessage("File uploaded successfully!");
                        $("#newDocsModal").modal("hide");
                        this.isEditMode = false;
                        this.getOrder();
                        this.getShippingDocument();
                        setTimeout(() => {
                            this.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    this.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    this.setLoading(false);
                });

            /*this.$refs.formValidation.validate().then(success => {
                if (!success) {
                    return;
                }
                this.saveOrder();
            });*/
            // this.$refs.formValidation.validateWithInfo().then((data) => {
            //     console.log(
            //         "success",
            //         data.isValid,
            //         data.errors,
            //         data.flags,
            //         data.fields
            //     );
            //     this.validationErrors = data;
            //     if (!data.isValid) {
            //         return;
            //     }
            //     this.saveOrder();
            // });
        },
        productArtworksUpdated(event) {
            this.getOrder();
        },
        openProductArtworksModal(product) {
            this.product = _.cloneDeep(product);
            setTimeout(() => {
                $("#productArtworksModal").modal("show");
            }, 100);
        },
        openProductArtworkVersionsModal(product) {
            this.product = _.cloneDeep(product);
            $("#productArtworkVersionsModal").modal("show");
        },
        openAllProductsArtworkVersionsModal() {
            $("#allProductsArtworkVersionsModal").modal("show");
        },
        getTotal() {
            let total =
                this.sub_total_cost +
                this.getTotalExtraAmount() -
                this.getDiscountAmount();
            return total.toFixed(2);
        },
        getTotalExtraAmount() {
            let total = 0;
            if (this.order && this.order.charges.length > 0) {
                this.order.charges.forEach((x) => {
                    if (
                        x.quantity != null &&
                        x.quantity != "" &&
                        x.quantity > 0
                    ) {
                        total += x.amount * x.quantity;
                    } else {
                        total += x.amount;
                    }
                });
            }
            return total;
        },
        editCharge(charge) {
            this.charge = _.cloneDeep(charge);
            //console.log(this.charge)
            this.bus.$emit("setChargeData", charge);
            $("#purchaseOrderExtraChargeModal").modal("show");
        },
        extraChargeUpdated(event) {
            if (event.oldData) {
                let index = this.order.charges.findIndex(
                    (x) => x.id == event.newData.id
                );
                if (index > -1) {
                    this.order.charges[index] = _.cloneDeep(event.newData);
                }
            } else {
                this.order.charges.push(_.cloneDeep(event.newData));
            }
            this.getOrder();
        },
        discountUpdated(event) {
            this.order.discounts = [_.cloneDeep(event)];
        },
        getDiscountAmount() {
            if (this.order && this.order.discounts.length > 0) {
                if (
                    this.order.discounts[0].isPercentage == "1" ||
                    this.order.discounts[0].isPercentage == 1
                ) {
                    return (
                        (this.sub_total_cost * this.order.discounts[0].amount) /
                        100
                    );
                } else {
                    return this.order.discounts[0].amount;
                }
            }
            return 0;
        },
        saveOrderNote() {
            let self = this;
            this.noteMessage = null;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("ps.notes.store", { id: this.order.id }),
                    {
                        so_id: this.order.id,
                        note_description: this.order_note,
                    },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.noteMessage = "Note saved successfully";
                        this.order_note = null;
                        self.getOrder();
                        setTimeout(() => {
                            this.noteMessage = null;
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        addNewItem() {},
        removeItem(id) {
            let self = this;
            Vue.$confirm({
                title: "Are you sure?",
                message: "Are you sure you want to delete?",
                button: {
                    yes: "Yes",
                    no: "Cancel",
                },
                callback: (confirm) => {
                    if (confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios
                            .delete(
                                window.route("po.products.destroy", {
                                    id: self.order.id,
                                    product_id: id,
                                }),
                                {
                                    validateStatus: function (status) {
                                        return status < 500; // Resolve only if the status code is less than 500
                                    },
                                }
                            )
                            .then(({ data }) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(
                                        "Product deleted from order!"
                                    );
                                    this.order.products.splice(
                                        this.order.products.indexOf(
                                            (x) => x.id == id
                                        ),
                                        1
                                    );
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(
                                    error.response &&
                                        error.response.errorMessage
                                        ? error.response.errorMessage
                                        : error.message
                                );
                            })
                            .finally(() => {
                                self.setLoading(false);
                            });
                    }
                },
            });
        },

        removeBillItem(id) {
            let self = this;
            Vue.$confirm({
                title: "Are you sure?",
                message: "Are you sure you want to delete?",
                button: {
                    yes: "Yes",
                    no: "Cancel",
                },
                callback: (confirm) => {
                    if (confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios
                            .delete(
                                window.route("po.bill.destroy", {
                                    id: id,
                                    
                                }),
                                {
                                    validateStatus: function (status) {
                                        return status < 500; // Resolve only if the status code is less than 500
                                    },
                                }
                            )
                            .then(({ data }) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(
                                        "Bill deleted !"
                                    );
                                    self.getShippingDocumentBill();
                                    // this.order.products.splice(
                                    //     this.order.products.indexOf(
                                    //         (x) => x.id == id
                                    //     ),
                                    //     1
                                    // );
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(
                                    error.response &&
                                        error.response.errorMessage
                                        ? error.response.errorMessage
                                        : error.message
                                );
                            })
                            .finally(() => {
                                self.setLoading(false);
                            });
                    }
                },
            });
        },

        removeDocumentItem(id) {
            let self = this;
            Vue.$confirm({
                title: "Are you sure?",
                message: "Are you sure you want to delete?",
                button: {
                    yes: "Yes",
                    no: "Cancel",
                },
                callback: (confirm) => {
                    if (confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios
                            .delete(
                                window.route("po.document.destroy", {
                                    id: id
                                    
                                }),
                                {
                                    validateStatus: function (status) {
                                        return status < 500; // Resolve only if the status code is less than 500
                                    },
                                }
                            )
                            .then(({ data }) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(
                                        "Document deleted!"
                                    );
                                    self.getShippingDocument();
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(
                                    error.response &&
                                        error.response.errorMessage
                                        ? error.response.errorMessage
                                        : error.message
                                );
                            })
                            .finally(() => {
                                self.setLoading(false);
                            });
                    }
                },
            });
        },

        dropzoneSendingEvent(index) {
            let dropzoneOptions = _.cloneDeep(this.dropzoneOptions);
            dropzoneOptions.prodIndex = index;
            return dropzoneOptions;
        },
        allArtworkUploadError(file, message, xhr, artworkIndex) {
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
        },
        afterAllArtworkUploadComplete(file, response, artworkIndex) {
            this.order.order.artworks[artworkIndex].media = _.cloneDeep(
                response.data.media
            );
            this.order.order.artworks[artworkIndex].media_id =
                response.data.media.id;

            if (this.order.order.artworks[artworkIndex].id == null) {
                this.order.products.forEach((product, pIndex) => {
                    this.order.products[pIndex].artworks.push({
                        id: null,
                        is_approve: 0,
                        attach_link: null,
                        comment: null,
                        updated_at: null,
                        media_id: response.data.media.id,
                        artwork_status_id: 4,
                    });
                });
            }
            this.saveOrder();
        },
        afterAllProductsOriginalFileUploadComplete(file, response) {
            this.order.order.media = _.cloneDeep(response.data.media);
            this.order.order.original_media_id = response.data.media.id;
            if (this.order.order.artworks.length) {
                this.order.order.artworks[
                    this.order.order.artworks.length - 1
                ].customer_file_media_id = response.data.media.id;
            } else {
                this.order.order.artworks.push({
                    id: null,
                    is_approve: 0,
                    attach_link: null,
                    comment: null,
                    updated_at: null,
                    media_id: null,
                    artwork_status_id: 3,
                    customer_file_media_id: response.data.media.id,
                });
            }
            this.saveOrder();
        },
        allProductsOriginalFileUploadError(file, message, xhr) {
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
        },
        afterItemOriginalFileUploadComplete(file, response, index) {
            this.order.products[index].media = _.cloneDeep(response.data.media);
            this.order.products[index].media_id = response.data.media.id;
            if (this.order.products[index].artworks.length) {
                this.order.products[index].artworks[
                    this.order.products[index].artworks.length - 1
                ].customer_file_media_id = response.data.media.id;
            } else {
                this.order.products[index].artworks.push({
                    id: null,
                    is_approve: 0,
                    attach_link: null,
                    comment: null,
                    updated_at: null,
                    media_id: null,
                    artwork_status_id: 3,
                    customer_file_media_id: response.data.media.id,
                });
            }
            this.saveOrder();
        },
        itemOriginalFileUploadError(file, message, xhr, index) {
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
        },
        afterArtworkUploadComplete(file, response, artworkIndex) {
            this.order.artworks[artworkIndex].media = _.cloneDeep(
                response.data.media
            );
            this.order.artworks[artworkIndex].media_id = response.data.media.id;
            //this.isEditMode = true;
            this.saveOrder();
        },
        otherAttachmentUploadError(file, message, xhr, artworkIndex) {
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
        },
        afterItemArtworkUploadComplete(file, response, index, artworkIndex) {
            this.order.products[index].artworks[artworkIndex].media =
                _.cloneDeep(response.data.media);
            this.order.products[index].artworks[artworkIndex].media_id =
                response.data.media.id;
            this.saveOrder();
        },
        itemArtworkUploadError(file, message, xhr, artworkIndex) {
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
        },
        addNewAllProductArtwork() {
            this.order.order.artworks.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                media_id: null,
                artwork_status_id: 1,
            });
        },
        removeAllProductArtwork(artworkIndex, artwork_id = null) {
            if (artwork_id) {
                let self = this;
                Vue.$confirm({
                    title: "Are you sure?",
                    message: "Are you sure you want to delete?",
                    button: {
                        yes: "Yes",
                        no: "Cancel",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            self.setLoading(true);
                            self.setCommonErrors([]);
                            self.setErrorMessage(null);
                            return axios
                                .delete(
                                    window.route("orders.artworks.destroy", {
                                        id: self.order.order.id,
                                        artwork_id: artwork_id,
                                    }),
                                    {
                                        validateStatus: function (status) {
                                            return status < 500; // Resolve only if the status code is less than 500
                                        },
                                    }
                                )
                                .then(({ data }) => {
                                    if (data.errorMessage) {
                                        self.setErrorMessage(data.errorMessage);
                                        if (data.errors) {
                                            self.setCommonErrors(data.errors);
                                        }
                                    } else {
                                        self.setSuccessMessage(
                                            "Artwork deleted!"
                                        );
                                        self.order.order.artworks.splice(
                                            artworkIndex,
                                            1
                                        );
                                        if (self.order.order.artworks.length) {
                                            self.order.order.latest_artwork =
                                                _.cloneDeep(
                                                    self.order.order.artworks[
                                                        self.order.order
                                                            .artworks.length - 1
                                                    ]
                                                );
                                        } else {
                                            self.order.order.latest_artwork =
                                                null;
                                        }
                                        self.getOrder();
                                        setTimeout(() => {
                                            self.setSuccessMessage(null);
                                        }, 5000);
                                    }
                                })
                                .catch((error) => {
                                    self.setErrorMessage(
                                        error.response &&
                                            error.response.errorMessage
                                            ? error.response.errorMessage
                                            : error.message
                                    );
                                })
                                .finally(() => {
                                    self.setLoading(false);
                                });
                        }
                    },
                });
            } else {
                this.order.order.artworks.splice(artworkIndex, 1);
            }
        },
        addNewItemAttachVersion(index) {
            this.order.products[index].artworks.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                media_id: null,
                artwork_status_id: 1,
            });
            this.isEditMode = true;
        },
        addNewItemAttach(index) {
            this.order.products[index].artworks.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                media_id: null,
                artwork_status_id: 1,
            });
        },
        removeItemAttach(index, artworkIndex, product_id, artwork_id = null) {
            if (artwork_id) {
                let self = this;
                Vue.$confirm({
                    title: "Are you sure?",
                    message: "Are you sure you want to delete?",
                    button: {
                        yes: "Yes",
                        no: "Cancel",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            self.setLoading(true);
                            self.setCommonErrors([]);
                            self.setErrorMessage(null);
                            return axios
                                .delete(
                                    window.route(
                                        "po.products.artworks.destroy",
                                        {
                                            id: self.order.id,
                                            product_id: product_id,
                                            artwork_id: artwork_id,
                                        }
                                    ),
                                    {
                                        validateStatus: function (status) {
                                            return status < 500; // Resolve only if the status code is less than 500
                                        },
                                    }
                                )
                                .then(({ data }) => {
                                    if (data.errorMessage) {
                                        self.setErrorMessage(data.errorMessage);
                                        if (data.errors) {
                                            self.setCommonErrors(data.errors);
                                        }
                                    } else {
                                        self.setSuccessMessage(
                                            "Artwork deleted!"
                                        );
                                        this.getOrder();
                                        self.order.products[
                                            index
                                        ].artworks.splice(artworkIndex, 1);
                                        setTimeout(() => {
                                            self.setSuccessMessage(null);
                                        }, 5000);
                                    }
                                })
                                .catch((error) => {
                                    self.setErrorMessage(
                                        error.response &&
                                            error.response.errorMessage
                                            ? error.response.errorMessage
                                            : error.message
                                    );
                                })
                                .finally(() => {
                                    self.setLoading(false);
                                });
                        }
                    },
                });
            } else {
                this.order.products[index].artworks.splice(artworkIndex, 1);
            }
        },
        goToCreateVendor() {},
        findShippingAddress() {},
        goToCreateCustomer() {},
        addNewOtherAttach() {
            this.order.artworks.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                artwork_status_id: 1,
            });
        },
        removeOtherAttach(artworkIndex, artwork_id = null) {
            if (artwork_id) {
                let self = this;
                Vue.$confirm({
                    title: "Are you sure?",
                    message: "Are you sure you want to delete?",
                    button: {
                        yes: "Yes",
                        no: "Cancel",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            self.setLoading(true);
                            self.setCommonErrors([]);
                            self.setErrorMessage(null);
                            return axios
                                .delete(
                                    window.route("po.artworks.destroy", {
                                        id: self.order.id,
                                        artwork_id: artwork_id,
                                    }),
                                    {
                                        validateStatus: function (status) {
                                            return status < 500; // Resolve only if the status code is less than 500
                                        },
                                    }
                                )
                                .then(({ data }) => {
                                    if (data.errorMessage) {
                                        self.setErrorMessage(data.errorMessage);
                                        if (data.errors) {
                                            self.setCommonErrors(data.errors);
                                        }
                                    } else {
                                        self.setSuccessMessage(
                                            "Artwork deleted!"
                                        );
                                        this.getOrder();
                                        self.order.artworks.splice(
                                            artworkIndex,
                                            1
                                        );
                                        setTimeout(() => {
                                            self.setSuccessMessage(null);
                                        }, 5000);
                                    }
                                })
                                .catch((error) => {
                                    self.setErrorMessage(
                                        error.response &&
                                            error.response.errorMessage
                                            ? error.response.errorMessage
                                            : error.message
                                    );
                                })
                                .finally(() => {
                                    self.setLoading(false);
                                });
                        }
                    },
                });
            } else {
                this.order.artworks.splice(artworkIndex, 1);
            }
        },
        addNewCustomerAttach() {},
        removeCustomerAttach(id) {},
        saveOrder(e) {
            let self = this;
            this.submitted = true;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .put(
                    window.route("purchase-orders.update", {
                        id: this.order.id,
                    }),
                    this.order,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.setSuccessMessage("Order saved successfully!");
                        self.isEditMode = false;
                        self.getOrder();
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        copyPoOrder() {
            let newOrder = {
                vendor: null,
                order_id: null,
                vendor_id: null,
                is_draft: 0,
                po_number: null,
                order_date: null,
                vendor_terms: null,
                vendor_po: null,
                vendor_fob: null,
                eta: null,
                delivery_date: null,
                notes: null,
                vendor_notes: null,
                po_status_id: 1,
                products: [],
                selectedProducts: [],
                quote_num: null,
            };

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.clone", { id: this.order.id }),
                    {},
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        newOrder = _.cloneDeep(data.data.order);
                        this.setNewPurchaseOrder(newOrder);
                        this.$router.push({ name: "purchaseSelectProducts" });
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        changeEditMode(mode) {
            this.isEditMode = mode;
        },
        changeEditModeProduct(mode,productIndex){
            this.isEditModeProduct = mode;

            console.log("this.shippingProducts.products",this.shippingProducts.products[productIndex]);
            this.product_form = {
                pivot_id:this.shippingProducts.products[productIndex].pivot.id,
                id:this.shippingProducts.products[productIndex].id,
                ship_id:this.$route.params.shipId,
                purchase_order_id:this.$route.params.id,
                shipped_units:this.shippingProducts.products[productIndex].pivot.quantity,
                pcs_per_case:this.shippingProducts.products[productIndex].pivot.pcs_per_case,
                cases_per_pallet:this.shippingProducts.products[productIndex].pivot.cases_per_pallet,
                total_cases:this.shippingProducts.products[productIndex].pivot.total_cases,
                amount_pallet:this.shippingProducts.products[productIndex].pivot.amount_pallet,
            }

            $("#editItemInfoModal").modal('show');
            console.log("product_form ",this.product_form);
        },
        artworkSampleRequiredEvent() {
            //this.changeEditMode(true);
            this.$refs.artworkRef.click();
        },
        getOrderStatuses() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("purchase-orders-status.index", {}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.statuses = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getQuantityUnits() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("so-quantity-units.index"), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.quantityUnits = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getOrder() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(
                    window.route("purchase-orders.show", {
                        id: this.$route.params.id,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.labels = _.cloneDeep(data.labels);
                        this.admin_users = _.cloneDeep(data.admin_users);
                        data.data.new_admin_users = [];
                        if (data.data.admin_users) {
                            data.data.admin_users.forEach((x) => {
                                data.data.new_admin_users.push(x.admin);
                            });
                        }

                        if (
                            data.data.order.artworks &&
                            data.data.order.artworks.length > 0 &&
                            data.data.order.latest_artwork == null
                        ) {
                            data.data.order.latest_artwork = _.cloneDeep(
                                data.data.order.artworks[
                                    data.data.order.artworks.length - 1
                                ]
                            );
                        }

                        data.data.products.forEach((x) => {
                            if (
                                x.order_product.artworks &&
                                x.order_product.artworks.length > 0 &&
                                x.order_product.latest_artwork == null
                            ) {
                                x.order_product.latest_artwork = _.cloneDeep(
                                    x.order_product.artworks[
                                        x.order_product.artworks.length - 1
                                    ]
                                );
                            }
                        });

                        this.order = data.data;
                        console.log(" this.order : ", this.order);
                        this.artwork_statuses = data.artwork_statuses;
                        this.eachProductsHasArtwork = false;

                        this.newLabelId = [];
                        this.order.labels.forEach((l) => {
                            this.newLabelId.push(l.id);
                        });

                        if (
                            this.order.order.original_customer_file &&
                            this.order.order.customer_file_media_id &&
                            this.order.order.artworks.length == 0
                        ) {
                            this.order.order.artworks.push({
                                id: null,
                                is_approve: 0,
                                attach_link: null,
                                comment: null,
                                updated_at: null,
                                media_id: null,
                                artwork_status_id: 1,
                                customer_file_media_id:
                                    this.order.order.customer_file_media_id,
                            });
                        }

                        if (this.order.products && this.order.products.length) {
                            this.eachProductsHasArtwork =
                                this.order.products.filter(
                                    (x) =>
                                        x.id &&
                                        x.order_product &&
                                        x.order_product.artworks &&
                                        x.order_product.artworks.filter(
                                            (y) => y.id && y.attach_link != null
                                        ).length > 0
                                ).length > 0;
                            this.sub_total_cost = 0;
                            this.order.products.forEach((x, index) => {
                                if (!isNaN(parseInt(x.cost))) {
                                    this.sub_total_cost += parseInt(x.cost);
                                }
                                if (
                                    x.order_product &&
                                    x.order_product.artworks &&
                                    x.order_product.artworks.length
                                ) {
                                    this.order.products[index].artworks =
                                        _.cloneDeep(x.order_product.artworks);
                                    this.order.products[index].latest_artwork =
                                        _.cloneDeep(
                                            x.order_product.latest_artwork
                                        );

                                    if (
                                        x.order_product
                                            .original_customer_file &&
                                        x.order_product.uploaded_media_id &&
                                        this.order.products[index].artworks
                                            .length == 0
                                    ) {
                                        x.artworks.push({
                                            id: null,
                                            is_approve: 0,
                                            attach_link: null,
                                            comment: null,
                                            updated_at: null,
                                            media_id: null,
                                            artwork_status_id: 1,
                                            customer_file_media_id:
                                                x.order_product
                                                    .uploaded_media_id,
                                        });
                                    }
                                }
                            });
                        }
                        this.getCompanyWarehouse();
                        this.getCustomerWarehouse();
                        this.getDueTasks();
                        this.bus.$emit("triggerGetTasks");
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },

    forceFileDownload(response, title) {
      console.log(title)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    downloadWithAxios(url, title) {
      axios({
        method: 'get',
        url,
        responseType: 'arraybuffer',
      })
        .then((response) => {
          this.forceFileDownload(response, title)
        })
        .catch(() => console.log('error occured'))
    },

        download(artwork) {
            let url = window.route("medias.download", {
                path: "so_attachments",
                id: this.order.order_id,
                name: artwork.attach_link,
                pdf_to_image: 0,
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(url, {
                    responseType: "blob",
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", artwork.attach_link);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        downloadOriginalArtwork(original_customer_file) {
            let url = window.route("medias.download", {
                path: "so_attachments",
                id: this.order.order.id,
                name: original_customer_file,
                pdf_to_image: 0,
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(url, {
                    responseType: "blob",
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", original_customer_file);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        updatedTaskEvent() {
            this.getOrder();
        },
        downloadPdf() {
            let url = window.route("po.download", { id: this.order.id });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(url, {
                    responseType: "blob",
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute(
                        "download",
                        "po_" + this.order.po_number + ".pdf"
                    );
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
    },
    watch: {
        "shippingData.tracking_no": {
            handler: function (after, before) {
                this.getShippingDetails();
                if (after != null) {
                    // alert("changed data " + after);
                }

                // if(after !== before) {
                //     this.saveOrder();
                // }
                this.shipmentId = null;
            },
        },
        "form.customer_warehouse":{
            handler: function (after, before) {
                if (after != null) {
                    let code = after;
                     //console.log(after, code);
                     let carriers = this.customerWarehouse.filter(
                         (x) => x.id == code
                     );
                    if (carriers.length) {
                         this.shippingData.destination = carriers[0].address;
                         
                     }
                    console.log("new data ",carriers);
                }
                 console.log("form.customer_warehouse daat ",this.customerWarehouse);
                console.log("form.customer_warehouse ",after);
            }
        },
        "form.company_warehouse":{
            handler: function (after, before) {
                
                if (after != null) {
                    let code = after;
                     //console.log(after, code);
                     let carriers = this.companyWarehouse.filter(
                         (x) => x.id == code
                     );
                     if (carriers.length) {
                         this.shippingData.destination = carriers[0].address;
                         
                     }

                   //this.form.destination = carriers.address;
                    console.log("new data ",carriers);
                }
                console.log("form.company_warehouse data ",this.companyWarehouse);
                console.log("form.company_warehouse ",after);
            }
        },

        /*"order.is_artwork_required": {
            handler: function (after, before) {
                if(after !== before) {
                    this.saveOrder();
                }
            }
        },
        "order.is_deposit_required": {
            handler: function (after, before) {
                if(after !== before) {
                    this.saveOrder();
                }
            }
        },
        "order.is_sample_required": {
            handler: function (after, before) {
                if(after !== before) {
                    this.saveOrder();
                }
            }
        }*/
    },
    computed: {
        ...mapState(["userState", "purchaseOrderState"]),
        ...mapGetters([
            "isAuth",
            "getAuthUser",
            "commonErrors",
            "errorMessage",
            "successMessage",
            "loading",
            "carriersState",
            "shipmentBackProduct"
        ]),
    },
};
</script>

<style scoped>
.error {
    color: red;
}
.dropzone-previews {
    display: none !important;
}
</style>
